<template>
  <div
    v-if="computedShareLinks.length"
    class="ShareLinkGroup"
  >
    <IconButton
      v-for="(link, index) in computedShareLinks"
      :key="index"
      :tag="link.tag"
      :to="link.to"
      plain
      class="ShareLinkGroup__link"
      @click="() => (link.action || (() => {}))()"
    >
      <VisionIcon
        class="ShareLinkGroup__icon"
        :icon="link.icon"
        colour="black"
        size="small"
      />
    </IconButton>
    <div
      v-show="urlCopied"
      :class="$b('copied-message-container')"
    >
      <span :class="$b('copied-message-text')">Copied to clipboard</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShareLinkGroup',

  data() {
    return {
      currentUrl: null,
      urlCopied: false,
    }
  },

  computed: {
    facebookShareUrl() {
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        this.currentUrl
      )}`
    },

    whatsAppShareUrl() {
      return `https://wa.me/?text=${encodeURIComponent(this.currentUrl)}`
    },

    computedShareLinks() {
      return [
        {
          tag: 'button',
          action: this.nativeShare,
          icon: 'share',
        },
        {
          tag: 'button',
          icon: 'copy',
          action: this.copyUrlToClipboard,
        },
        {
          tag: 'a',
          to: this.whatsAppShareUrl,
          icon: 'whatsapp',
        },
      ]
    },
  },

  mounted() {
    this.currentUrl = window.location.href
  },

  methods: {
    copyUrlToClipboard() {
      try {
        navigator.clipboard.writeText(this.currentUrl)
        this.showCopiedMessage()
      } catch (error) {
        console.error(error)
      }
    },

    async nativeShare() {
      await navigator.share({
        url: window.location.href,
        text: this.title,
      })
    },

    showCopiedMessage() {
      this.urlCopied = true
      setTimeout(() => {
        this.urlCopied = false
      }, 3000)
    },
  },
}
</script>

<style lang="postcss">
.ShareLinkGroup {
  @apply flex relative;
}

.ShareLinkGroup__link {
  &:not(:first-child) {
    @apply lg:ml-xxs;

    margin-left: 20px;
  }

  &:hover .ShareLinkGroup__icon {
    fill: var(--gradient-url) !important;
  }
}

.ShareLinkGroup__icon {
  @apply m-xxs;
}

.ShareLinkGroup__copied-message-container {
  @apply absolute bg-grey-light px-xxxs top-md ml-xxxs;
  padding-top: calc(theme('spacing.xxs') / 2);
  padding-bottom: calc(theme('spacing.xxs') / 2);
  border-radius: 4px;
}

.ShareLinkGroup__copied-message-text {
  @apply t-align-fix text-xxs md:text-xs tracking-wider leading-tight font-semibold;
  background-image: var(--gradient-default);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
